import React, { useContext} from 'react';
import { useTranslation } from "react-i18next";
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import OrderListView from "../OrderListView";
import {Context} from "../../core/Context";
import Paper from "@mui/material/Paper";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import HomeIcon from "@mui/icons-material/Home";
import ListAltIcon from "@mui/icons-material/ListAlt";


const useStyles = makeStyles((theme) => ({
    root: {},
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none'
    },
    list: {
        paddingTop: 0
    },
    listSection: {
        backgroundColor: 'inherit',
    },
    ul: {
        backgroundColor: 'inherit',
        padding: 0,
    },
}));


export default function OrderList() {
    const { t } = useTranslation();
    const classes = useStyles();
    const [context] = useContext(Context);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        if(newValue === 0) {
            window.location.href = '/home';
        } else if(newValue === 1) {
            window.location.href = '/orders';
        }
    };

    return (
        <div className={classes.root}>
            <Box display="flex" justifyContent="space-between" alignItems="center" m={1}>
                <Typography variant="h6">
                    {t('orders.title')}
                </Typography>
            </Box>
            <Divider style={{'marginBottom': '10px', 'marginTop': '10px'}} />
            <Box m={1}>
                <OrderListView mode="all" cid={context.cid} />
            </Box>
            <Box mt={4}>
                <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
                    <BottomNavigation
                        showLabels
                        value={1}
                        onChange={handleChange}
                    >
                        <BottomNavigationAction label={t('dashboard.title')} icon={<HomeIcon />} />
                        <BottomNavigationAction label={t('orders.title')} icon={<ListAltIcon />} />
                    </BottomNavigation>
                </Paper>
            </Box>
        </div>
    )
}